import { fetchAPI } from "packs/api";

document.addEventListener("click", (event) => {
  const moreRepliesButton = event.target.closest(".moreReplies");
  if (moreRepliesButton) {
    const parentElement = moreRepliesButton.parentElement;

    let currentPage = parseInt(parentElement.dataset.currentPage) || 0;
    currentPage++;
    parentElement.dataset.currentPage = currentPage;

    const parentId = moreRepliesButton.id;
    const urlParams = new URLSearchParams(window.location.search);
    const sortBy = urlParams.get("sort_by");
    const urlComments = `/child_comments_by_parent?post_id=${parentId}&sub_page=${currentPage}&per_page=10&sort_by=${sortBy}`;
    fetchAPI(urlComments, "GET", {}, "script")
      .then((response) => {})
      .catch((error) => {
        console.error("Error loading replies:", error);
      });
  }
});

setTimeout(() => {
  const deleteSection = document.querySelector(".deleteSection");
  if (deleteSection) {
    deleteSection.style.transition = "height 1s, opacity 1s";
    deleteSection.style.height = "0px";
    deleteSection.style.opacity = "0";
    setTimeout(() => {
      deleteSection.remove();
    }, 1000);
  }
}, 4000);
const commentUrl = window.location.href;
const pieces = commentUrl.split("#");

function highlight() {
  const targetElement = document.getElementById(pieces[1]);
  if (targetElement) {
    targetElement.classList.add("highlight");
    setTimeout(() => {
      targetElement.classList.remove("highlight");
    }, 3000);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const targetElement = document.getElementById(pieces[1]);
    if (targetElement) {
      const offset = targetElement.getBoundingClientRect();
      window.scrollTo({
        top: offset.top + window.scrollY - 100,
        left: offset.left + window.scrollX,
        behavior: "smooth",
      });
      highlight();
    }
  }, 2000);
});